import React from 'react'
import { Modal, Box, Text } from '@workwhile/ui'

interface AgentReasoningModalProps {
  open: boolean
  onClose: () => void
  reasoning: string
}

export const AgentReasoningModal: React.FC<AgentReasoningModalProps> = ({
  open,
  onClose,
  reasoning,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Agent Reasoning"
      // @ts-expect-error width is not typed
      width="90vw"
      maxWidth="800px"
    >
      <Box maxHeight="70vh" overflowY="auto">
        <Text fontSize={2} style={{ whiteSpace: 'pre-wrap' }}>
          {reasoning}
        </Text>
      </Box>
    </Modal>
  )
}
